import { apiClient } from '@/shared/services/api';

export interface CompanyInventoryItem {
  inputId: string;
  inputCode: string;
  inputName: string;
  category: string | null;
  currentStock: number;
  unitOfMeasure: string;
  totalSeedCount: number | null;
  reorderLevel: number;
  isLowStock: boolean;
  source: string;
}

export interface CustomerSeedBatchItem {
  seedBatchId: string;
  batchNumber: string;
  customerName: string;
  customerId: string;
  cropType: string;
  variety: string | null;
  quantityAvailable: number;
  unit: string;
  storageLocation: string | null;
  receivedDate: string;
  source: string;
}

export interface UnifiedInventorySummary {
  totalCompanyItems: number;
  totalCustomerBatches: number;
  lowStockAlerts: number;
}

export interface UnifiedStoreInventory {
  companyInventory: CompanyInventoryItem[];
  customerSeedBatches: CustomerSeedBatchItem[];
  summary: UnifiedInventorySummary;
  currentPage: number;
  pageSize: number;
  totalPages: number;
  batchCurrentPage: number;
  batchPageSize: number;
  batchTotalPages: number;
}

export const storeInventoryApi = {
  getUnifiedInventory: async (params?: {
    search?: string;
    category?: string;
    includeCustomerSeeds?: boolean;
    pageNumber?: number;
    pageSize?: number;
    batchPageNumber?: number;
    batchPageSize?: number;
  }): Promise<UnifiedStoreInventory> => {
    const searchParams = new URLSearchParams();
    if (params?.search) searchParams.set('search', params.search);
    if (params?.category) searchParams.set('category', params.category);
    if (params?.includeCustomerSeeds === false) searchParams.set('includeCustomerSeeds', 'false');
    if (params?.pageNumber) searchParams.set('pageNumber', String(params.pageNumber));
    if (params?.pageSize) searchParams.set('pageSize', String(params.pageSize));
    if (params?.batchPageNumber) searchParams.set('batchPageNumber', String(params.batchPageNumber));
    if (params?.batchPageSize) searchParams.set('batchPageSize', String(params.batchPageSize));
    const query = searchParams.toString();
    const response = await apiClient.get(`/Stock/unified-inventory${query ? `?${query}` : ''}`);
    return response.data.data ?? response.data;
  },
};

